import { MoonOutlined, SunOutlined, SyncOutlined } from "@ant-design/icons";
import { Button, Dropdown } from "antd";

import { ColorMode } from "../store/store";

import { useColorMode } from "../hooks/ui";

const modes: ColorMode[] = ["light", "dark", "auto"];

const getDisplay = (mode: ColorMode) =>
    mode === "light" ? <SunOutlined /> : mode === "dark" ? <MoonOutlined /> : <SyncOutlined />;

export default function ColorModeSwitcher() {
    const { mode, setMode } = useColorMode();

    return (
        <Dropdown
            menu={{
                items: modes.map((m) => ({
                    label: getDisplay(m),
                    key: m,
                    // icon: getDisplay(m),
                    type: "item",
                    onClick: () => {
                        setMode(m);
                    },
                })),
            }}
            trigger={["click"]}>
            <Button type="default">{mode && getDisplay(mode)}</Button>
        </Dropdown>
    );
}
